import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// components
import { LoginComponent } from './login/login.component';
import { LoginSSOComponent } from './login/login-sso.component';
import { InvalidPageComponent } from './layout/invalid-page.component';
import { UnauthorizedComponent } from './layout/unauthorized.component';
import { MainComponent } from './layout/main.component';
import { HeaderComponent } from './layout/header.component';
import { FooterComponent } from './layout/footer.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { RecurrentTourComponent } from './recurrence/recurrent-tour.component';
import { RecurrentTourListComponent } from './recurrence/recurrent-tour-list.component';
import { RecurrentTourFormComponent } from './recurrence/recurrent-tour-form.component';
import { RecurrentOrderFormComponent } from './recurrence/recurrent-order-form.component';

// services
import { AuthGuard } from './core/auth-guard.service';
import { TourResolver } from './shared/resolvers/tour.resolver';
import { OrderTemplateResolver } from './shared/resolvers/orderTemplate.resolver';

const authenticatedRoutes: Routes = [
  { path: '', component: HeaderComponent, outlet: 'header' },
  { path: '', component: FooterComponent, outlet: 'footer' },
  { path: '', redirectTo: 'recurrence/tour', pathMatch: 'full' },
  { path: 'recurrence/tour', component: RecurrentTourComponent, resolve: { tour: TourResolver } },
  { path: 'recurrence/order', component: RecurrentOrderFormComponent, resolve: { orderTemplate: OrderTemplateResolver } },
  { path: 'schedule', component: MainComponent, children: [
    { path: '', component: ScheduleComponent }
  ] }
];

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'loginSSO', component: LoginSSOComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '', canActivate: [AuthGuard], children: authenticatedRoutes },
  { path: '**', component: InvalidPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, TourResolver, OrderTemplateResolver]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts